module.exports = __webpack_public_path__ + "img/bg-login.af784de4.png";